import React, { useRef, useEffect } from "react";
import { Input } from "antd";
import type { InputRef } from "antd";
import { ColorPalette } from "./color/colorPalette";

interface OTPInputProps {
  length: number;
  onChange: (otp: string) => void;
  customSize?: "XLarge" | "Large";
}

const TedOTP: React.FC<OTPInputProps> = ({ length, onChange, customSize }) => {
  const inputsRef = useRef<(InputRef | null)[]>([]);

  useEffect(() => {
    inputsRef.current[0]?.focus();
  }, []);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const value = e.target.value;
    if (value.length > 1 || !/^[0-9]*$/.test(value)) return;

    if (inputsRef.current[index]) {
      (inputsRef.current[index]!.input as HTMLInputElement).value = value;
    }

    const newOtp = inputsRef.current
      .map((input) => input?.input?.value || "")
      .join("");
    onChange(newOtp);

    if (value && index < length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (
      e.key === "Backspace" &&
      !inputsRef.current[index]?.input?.value &&
      index > 0
    ) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  return (
    <div
      style={{
        display: "inline-flex",
        gap: "8px",
        textAlign: "center",
        width: "287px",
      }}
      dir="ltr"
    >
      {Array.from({ length }).map((_, index) => (
        <>
          <div
            style={{
              borderBottom: "1px solid",
              width: customSize === "Large" ? "64px" : "48px",
              height: customSize === "Large" ? "64px" : "48px",
              marginLeft: customSize === "Large" ? "16px" : "4px",
              marginRight: customSize === "Large" ? "16px" : "4px",
              borderColor: ColorPalette.gray[600],
            }}
          >
            <Input
              key={index}
              ref={(el:any) => (inputsRef.current[index] = el)}
              maxLength={1}
              onChange={(e) => handleInputChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              placeholder="-"
              style={{
                width: "40px",
                height: "40px",
                textAlign: "center",
                fontSize: "24px",
                border: "none",
                boxShadow: "none",
              }}
            />
          </div>
        </>
      ))}
    </div>
  );
};

export default TedOTP;
